import Image from "next/image";
import HomeHeroSection from "@/components/home/HomeHeroSection ";
import ServiceArea from "@/components/home/ServiceSection";
import CoursesArea from "@/components/home/CourseArea";
import ChooseArea from "@/components/home/ChooseArea";
import HomeAdmission from "@/components/home/HomeAdmission";
import ClassesSection from "@/components/home/ClassesSection";
import ProgramSlider from "@/components/home/ProgramSection";
import NewsSection from "@/components/home/NewsSection";
import TeachersSection from "@/components/home/TeachersSection";
import ContactSection from "@/components/ContactArea";

export default function Home() {
  return (
    <>
      <HomeHeroSection />
      <ServiceArea />

      {/* <div className="shape-ellips">
        <Image src="/images/shape.png" alt="shape" fill className="position-relative" />
      </div> */}
      <ChooseArea />
      <CoursesArea />

      <HomeAdmission />
      <ClassesSection />
      {/* <ProgramSlider />
      <span className="left-shape">
        <Image src="/images/left-shape.png" alt="shape" fill className="position-relative" />
      </span>
      <NewsSection /> */}
      {/* <TeachersSection />
      <ContactSection /> */}
    </>
  );
}
